var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fb-signin-button',{attrs:{"params":_vm.fbSignInParams},on:{"success":_vm.onFacebookSignInSuccess,"error":_vm.onFacebookSignInError}},[_c('button',{staticClass:"btn btn--tondo btn-block my-2"},[_vm._v("Facebook")])])}
var staticRenderFns = []

export { render, staticRenderFns }